import { AXIOS_ERP } from "../Config/api.config";

export const AuthErpService = () => {
  return {
    login: (data) => AXIOS_ERP.post("wind-auth/authenticate", data),
  };
};
